<template>
  <label for="ul-toggle" class="flex w-full cursor-pointer items-center gap-4 select-none" @click="click">
    <div class="relative">
      <input type="checkbox" id="ul-pluss-toggle" class="sr-only" :value="modelValue" />
      <div
        class="box block h-8 w-14 rounded-full transition-all duration-200"
        :style="`background: ${modelValue ? '#F34E35' : '#cccccc'}`"
      />
      <div
        class="dot absolute top-1 left-1 flex h-6 w-6 transform items-center justify-center rounded-full bg-white transition-all duration-200"
        :class="[modelValue ? 'translate-x-full' : '']"
      />
    </div>
    <span>
      {{ label }}
    </span>
  </label>
</template>

<script setup lang="ts">
type Props = {
  modelValue?: boolean
  activeColor?: string
  label?: string
}
const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  label: '',
})
const emit = defineEmits<{ 'update:modelValue': [value: boolean] }>()

function click() {
  emit('update:modelValue', !props.modelValue)
}
</script>

<style></style>
